// extracted by mini-css-extract-plugin
export default {"root":"AuthError_root__3EEYu","header":"AuthError_header__nD1us","body":"AuthError_body__VMEHT","footer":"AuthError_footer__cRp59","button":"AuthError_button__wlu8h"};